import React from 'react';
import OrderFollowupPage from './OrderFollowupPage';

const DeliveryOrderFollowup = () => (
  <OrderFollowupPage title="Delivery Order Followup" endpoint="GetOrderInDFollowup" />
);

export default DeliveryOrderFollowup;
